export const createSetting = (type = "TextInput", value = "") => ({
	type,
	translations: {},
	permission: "Admin",
	value,
});

export const parseTabOrder = (value = "") =>
	value
		.split(",")
		.map((tab) => tab.trim())
		.filter(Boolean);

export const scheduleMissingSettingUpdate = ({
	getCurrentSetting,
	onMissing,
	delay = 5000,
}) =>
	setTimeout(() => {
		if (getCurrentSetting() !== undefined) return;
		void onMissing();
	}, delay);
